import React, { ChangeEvent, FC, useState } from 'react';
import ModalComponent from 'ReusableComponents/Modal/ModalComponent';
import { ButtonComponent } from 'ReusableComponents/Button/ButtonComponent';
import { InputComponent } from 'ReusableComponents/Input/InputComponent';
import { updateShiftNote } from '../shiftApi';
import { handleError } from '../utils';

const ShiftNoteModal: FC<{
  shiftId: string;
  currentNote: string;
  showModal: boolean;
  setShowModal: (open: boolean) => void;
}> = ({ shiftId, currentNote, showModal, setShowModal }) => {
  const [note, setNote] = useState(currentNote);

  return (
    <ModalComponent open={showModal} setOpen={setShowModal}>
      <InputComponent
        id=""
        label="Note"
        name=""
        rows="4"
        value={note}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setNote(e.currentTarget.value)
        }
        variant="outlined"
        textAreaMode
      />
      <div>
        <ButtonComponent
          text="OK"
          disabled={note === currentNote}
          onClick={() => {
            updateShiftNote(shiftId, note).catch(handleError);
            setShowModal(false);
          }}
        />
        <ButtonComponent
          text="Cancel"
          variant="outlined"
          onClick={() => setShowModal(false)}
        />
      </div>
    </ModalComponent>
  );
};

export default ShiftNoteModal;
